module.exports = __webpack_public_path__ + "static/baskar-f63193157bd89c36a536aca0e6a2d371.png";